<dx-box direction="col" width="100%" height="100%">
    <dxi-item [ratio]="1">
        <div *dxTemplate>
            <dx-scroll-view direction="both" width="100%" height="100%">
                <div class="contact-us-tile-view">
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'far fa-compass',
                                iconClass: 'cc-icon-lightGray icon-big',
                                bgClass: 'cc-bg-lightBlue',
                                htmlText: 'New Navigation',
                                helpKey: navigationHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-vote-yea',
                                iconClass: 'cc-icon-green icon-big',
                                bgClass: 'cc-bg-darkBlue',
                                htmlText: 'Board Approval - Invoices',
                                helpKey: boardapprovalsInvHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-house-user',
                                iconClass: 'cc-icon-cyan icon-big',
                                bgClass: 'cc-bg-navy',
                                htmlText: 'Property Owner Search',
                                helpKey: propertyOwnerSeaarchHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-search-dollar',
                                iconClass: 'cc-icon-rgb-orange icon-big',
                                bgClass: 'cc-bg-blue',
                                htmlText: 'Payables Lockbox - Search Invoices',
                                helpKey: payableLockboxSearchInvHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-newspaper',
                                iconClass: 'cc-icon-slate icon-big',
                                bgClass: 'cc-bg-lightBlue',
                                htmlText: 'Custom Workspaces',
                                helpKey: customWorkspaceHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-hand-holding-usd',
                                iconClass: 'cc-icon-red icon-big',
                                bgClass: 'cc-bg-darkBlue',
                                htmlText: 'Board Approval - Collections',
                                helpKey: boardapprovalsCollationHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-folder-open',
                                iconClass: 'cc-icon-lightYellow icon-big',
                                bgClass: 'cc-bg-navy',
                                htmlText: 'Community Documents',
                                helpKey: communityDocHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-file-invoice-dollar',
                                iconClass: 'cc-icon-violet icon-big',
                                bgClass: 'cc-bg-blue',
                                htmlText: 'Payables Lockbox - Submit Invoices',
                                helpKey: payableLockboxSubmitInvHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-sort-amount-down',
                                iconClass: 'cc-icon-maroon icon-big',
                                bgClass: 'cc-bg-lightBlue',
                                htmlText: 'Custom Reporting -  Grids and Pager',
                                helpKey: customReportingGridPageHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-drafting-compass',
                                iconClass: 'cc-icon-gold icon-big',
                                bgClass: 'cc-bg-darkBlue',
                                htmlText: 'Board / Committee Approvals - Architectural',
                                helpKey: boardApprovalsArchitecturalHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-calendar-alt',
                                iconClass: 'cc-icon-darkViolet icon-big',
                                bgClass: 'cc-bg-navy',
                                htmlText: 'Community Calendar',
                                helpKey: communityCalHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-file-signature',
                                iconClass: 'cc-icon-seafoamGreen icon-big',
                                bgClass: 'cc-bg-blue',
                                htmlText: 'Vendor Contracts and Insurance',
                                helpKey: vendorContractsInsuranceHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-receipt',
                                iconClass: 'cc-icon-aqua icon-big',
                                bgClass: 'cc-bg-lightBlue',
                                htmlText: 'Community Reports',
                                helpKey: communityReportsHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-balance-scale',
                                iconClass: 'cc-icon-silver icon-big',
                                bgClass: 'cc-bg-darkBlue',
                                htmlText: 'Financials - Actual vs. Budget',
                                helpKey: finActualBudgetHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'far fa-address-book',
                                iconClass: 'cc-icon-rust icon-big',
                                bgClass: 'cc-bg-navy',
                                htmlText: 'Resident Directory',
                                helpKey: residentDirectoryHelpKey
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-people-carry',
                                iconClass: 'cc-icon-white icon-big',
                                bgClass: 'cc-bg-blue',
                                htmlText: 'More...',
                                helpKey: welcomeHelpKey
                            }
                        }"
                    ></ng-container>
                </div>
            </dx-scroll-view>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto">
        <div *dxTemplate class="cc-text-center">
            <span>
                You can call us at
                <strong>
                    <a href="tel:{{ contactUsPhone }}">{{ contactUsPhoneDisplayText }}</a>
                </strong>
                or Email us at
                <strong>
                    <a href="mailto:{{ contactEmail }}">{{ contactEmail }}</a>
                </strong>
            </span>
        </div>
    </dxi-item>
</dx-box>

<ng-template #contactUsTile let-data="data">
    <div
        *ngIf="data.htmlText"
        class="contact-us-tile"
        [ngClass]="data.bgClass"
        (mouseenter)="onToolMouseEnter($event, data)"
        (mouseleave)="onToolMouseLeave($event)"
        (click)="onTileClick(data.helpKey)"
    >
        <div class="icon-content">
            <i [ngClass]="data.icon" class="{{ data.iconClass }}"></i>
        </div>
        <div class="text-content dx-theme-background-color-as-text-color">
            <span [innerHTML]="data.htmlText | ccSafeHtml"></span>
        </div>
    </div>
</ng-template>
